import React from 'react';
import { Reveal } from '../Reveal';
import { useLanguage } from '../../contexts/LanguageContext';
export function WhyUs() {
  const {
    t
  } = useLanguage();
  return <section id="why-us" className="relative overflow-hidden bg-ink py-24 sm:py-32" aria-labelledby="why-us-heading" data-id="element-341" data-mp="163fmjstpzu4r">
      <div className="pointer-events-none absolute -right-32 top-0 h-[480px] w-[480px] rounded-full bg-brand/[0.14] blur-3xl" aria-hidden="true" data-id="element-342" data-mp="1fzirt7jvc8vx" />
      <div className="relative mx-auto max-w-shell px-5 sm:px-8" data-id="element-343" data-mp="1kydgur8fitoh">
        <Reveal data-id="element-344" data-mp="1ozozudwssgnp">
          <div className="max-w-[720px]" data-id="element-345" data-mp="1oz5r9nt1f4mc">
            <p className="text-[12px] font-semibold uppercase tracking-[0.2em] text-brand" data-id="element-346" data-mp="1oy44im2nstos">
              {t.whyUs.eyebrow}
            </p>
            <h2 id="why-us-heading" className="headline mt-5 text-[32px] font-bold text-white sm:text-[46px]" data-id="element-347" data-mp="1yqjmvkhvbka7">
              {t.whyUs.heading}
            </h2>
          </div>
        </Reveal>

        <ul className="mt-16 grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-348" data-mp="28noalord3nt4">
          {t.whyUs.items.map((item, i) => <Reveal as="li" key={item.title} delay={i * 0.07} data-id="element-349" data-mp="18qijerph3vg8" data-mpi={i}>
              <div className="glass-dark group h-full rounded-3xl border border-white/10 p-8 transition-all duration-300 hover:-translate-y-1.5 hover:border-white/25 hover:bg-white/[0.1]" data-id="element-350" data-mp="13r5nzikjdg21">
                <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-brand text-[13px] font-bold text-white" data-id="element-351" data-mp="ytw1aaoj7ihw">
                  {String(i + 1).padStart(2, '0')}
                </span>
                <h3 className="mt-6 text-[19px] font-semibold tracking-tight text-white" data-id="element-352" data-mp="1riktfk7m0dhi">{item.title}</h3>
                <p className="mt-3 text-[15px] leading-relaxed text-white/60" data-id="element-353" data-mp="1hqx9e4ddtyq2">{item.body}</p>
              </div>
            </Reveal>)}
        </ul>
      </div>
    </section>;
}